export type MentorHeardAboutMentorshipValues =
  | 'FRIEND'
  | 'NEWSLETTER'
  | 'SOCIAL_NETWORKS'
  | 'VOLUNTEER'
  | 'ORGANISM'
  | 'PRESENTATION'
  | 'PUBLIC_SPACE'
  | 'WEB'
  | 'VOLUNTEERING_WEBSITE'
  | 'FORGOT'
  | 'OTHER';

export const mentorHeardAboutMentorships: MentorHeardAboutMentorshipValues[] = [
  'FRIEND',
  'NEWSLETTER',
  'SOCIAL_NETWORKS',
  'VOLUNTEER',
  'ORGANISM',
  'PRESENTATION',
  'PUBLIC_SPACE',
  'WEB',
  'VOLUNTEERING_WEBSITE',
  'FORGOT',
  'OTHER',
];

enum MENTOR_HEARD_ABOUT_MENTORSHIP {
  FRIEND = "Une connaissance m'en a parlé",
  NEWSLETTER = "J'ai reçu une newsletter de l'Institut de l'Engagement",
  SOCIAL_NETWORKS = "J'ai vu une publication sur les réseaux sociaux",
  VOLUNTEER = "Lors d'une autre action bénévole pour l'Institut de l'Engagement",
  ORGANISM = 'Mon entreprise ou établissement de formation m’en a parlé',
  PRESENTATION = "J'ai assisté à une réunion de présentation",
  PUBLIC_SPACE = "J'ai vu un affichage dans l'espace public",
  WEB = "J'ai fait des recherches sur internet",
  VOLUNTEERING_WEBSITE = "J'ai vu la mission sur un site de bénévolat citoyen",
  FORGOT = 'Je ne me souviens plus',
  OTHER = 'Autre',
}
export default MENTOR_HEARD_ABOUT_MENTORSHIP;
